export const enTranslation = {
  // People
  peopleTitle: "People",
  all: "All",
  employees: "Employees",
  contractors: "Contractors",
  visitors: "Visitors",
  employee: "Employee",
  contractor: "Contractor",
  visitor: "Visitor",
  firstName: "First name",
  lastName: "Last name",
  email: "Email",
  company: "Company",
  phoneNumber: "Phone number",
  taxNumber: "Tax number",
  userType: "User type",
  dateOfBirth: "Date of birth",
  addPerson: "+ Add Person",
  deletePerson: "- Delete Person",
  deleteConfirmation: "Are you sure you want to remove these people?",
  deletePartConfirmation: "Are you sure you want to delete?",
  cannotRemoveManager: "Cannot remove a manager.",
  invitePeople: "Invite people:",
  inviteToCourse: "Invite to course",
  readedTos: "I have read and accepted",
  tos: "terms of services",
  personalInformation: "Personal information",
  occupationalSafetyCard: "Occupational safety card number",
  hotWorkCard: "Hot work card number",
  occupationalSafetyCardImage: "Occupational safety card image",
  firstAidCardImage: "First aid card image",
  hotWorkCardImage: "Hot work card image",
  shoeSize: "Outdoor shoe size",
  jacketSize: "Jacket size (Unisex: S / M / L / XL / XXL)",
  dietaryRestrictions: "Dietary restrictions (optional)",
  visitationDate: "Visitation date",
  search: "Search...",
  density: "Density",
  small: "Small",
  medium: "Medium",
  large: "Large",
  columns: "Columns",
  filter: "Filter",
  export: "Export",
  saveAndInvite: "Save and invite",
  savedImage: "Image saved",
  addUser: "New participant",
  requireNewUserCreation: "Create a new user by QR-code",
  verificationCode: "Verification code",
  checkVerificationCode: "Check verification code.",
  askToVerify: "Enter the verification code sent to your email to continue to the training.",
  askToVerifySpam: "If the message does not arrive within a few minutes, please also check your spam folder.",
  askToVerifySupport: "Technical support: +358409123514",
  willSendVerificationCode: "We will send a verification code to your email to verify your account.",
  sendVerificationCode: "Send code",
  emailInUse: "Email already in use",
  phoneInUse: "Phone number already in use",
  // Courses
  coursesTitle: "Courses",
  courses: "Courses",
  newCourse: "+ New course",
  deleteCourseConfirmation: "Are you sure you want to remove this course?",
  addSlide: "+ Add Slide",
  backgroundImage: "Background image:",
  recurrency: "Recurrency:",
  none: "None",
  monthly: "Monthly",
  yearly: "Yearly",
  previousSlide: "Previous slide",
  nextSlide: "Next slide",
  chooseLayout: "Choose page layout",
  video: "Video",
  quiz: "Quiz",
  status: "Status",
  completed: "Completed",
  name: "Name",
  description: "Description",
  completedDate: "Completed d/m/y",
  addImage: "Add image",
  changeImage: "Change image",
  fillMode: "Fill mode",
  deleteSlide: "Delete Slide",
  organize: "Organize slides",
  moveUp: "Move up",
  moveDown: "Move down",
  newAnswer: "+ New answer",
  newQuestion: "+ New question",
  checkAnswers: "Check answers",
  deleteSlideConfirmation: "Are you sure you want to delete this slide?",
  textContent: "Text",
  imageContent: "Image",
  videoContent: "Video",
  quizContent: "Quiz",
  oneElementLayout: "One element",
  oneElementWithTitleLayout: "One element and title",
  twoColumnsWithTitleLayout: "Two elements and title",
  twoColumnsLayout: "Two elements",
  threeElementsWithTitleLayout: "Three elements and title",
  threeElementsLayout: "Three elements",
  generatePublicLink: "Generate public link for preview",
  result: "Result",
  passed: "Passed",
  failed: "Failed",
  required: "Required",
  tryAgain: "Try again",
  howManyQuestions: "How many questions are shown?",
  howManyCorrectAnswers: "How many correct answers are required?",
  send: "Send",
  slides: "Slides",
  info: "Info",
  Unfinished: "Unfinished",
  welcomeToCourse: "Welcome to the course",
  checkPassword: "Check the password",
  password: "Password",
  confirm: "Confirm",
  missingFieldsTitle: "Fill missing information",
  tosDisclaimer:
    "Before you can start the course, you must accept the terms of service and enter the course password you received in the email",
  selectCourses: "Select the courses you want to invite people to.",
  message: "Message",
  messageContent: "Message",
  messages: "Messages",
  includeName: "Include name",
  sentMessage: "Message sent!",
  messageError: "There was an error sending the message, try again later.",
  allowIncludeName: "Allow sending anonymous messages",
  selectImage: "Select image or add a new one",
  selectAnImage: "Select image",
  gallery: "Gallery",
  ownImages: "Own images",
  uploadImage: "Upload a new image",
  addToGallery: "Add an image to gallery",
  addBackgroundImage: "Add a background image",
  changeBackgroundImage: "Change background image",
  deleteBackgroundImage: "Remove background image",
  deleteFromGallery: "Remove image from gallery",
  qrLabel: "QR code label",
  duplicateSlide: "Duplicate slide",
  requireUserTracking: "Require user tracking with public link",
  askUserName: "Enter your email address to continue.",
  askEmail: "Email",
  username: "Username",
  publicCourses: "Public links:",
  allowPublicCourses: "Allow completing courses through public links",
  lastEdited: "Last edited in: ",
  messageTitle: "Message title",
  emailNotifications: "Email notifications",
  notifyByEmail: "Notify when a user completes this course",
  enterEmail: "Enter email",
  addMyEmail: "Add my email to the notification list",
  basic: "Basic information",
  newUserType: "Status for new users (optional)",
    // Common
  errorOccured: "An error occured",
  ok: "OK",
  cancel: "Cancel",
  edit: "Edit",
  save: "Save",
  back: "Back",
  logout: "Log out",
  login: "Login",
  logoutConfirmation: "Log out?",
  // Settings
  settings: "Settings",
  peopleInfo: "People info",
  isTaxNumberVisible: "User's tax number",
  isPhoneVisible: "User's phone",
  isCompanyVisible: "User's company",
  isSafetyCardVisible: "User's occupational safety card",
  isHotWorkCardVisible: "User's hot work card",
  isDateOfBirthVisible: "User's date of birth",
  isSafetyCardImageVisible: "User's occupational safety card image",
  isFirstAidCardVisible: "User's first aid card image",
  isHotWorkCardImageVisible: "User's hot work card image",
  isShoeSizeVisible: "User's shoe size",
  isJacketSizeVisible: "User's jacket size",
  isDietaryRestrictionsVisible: "User's dietary restrictions",
  isVisitationDateVisible: "Visitation date"
};
